export function getRowColor(data, index) {
    return sl.getRowColor("fsr", data, index, false);
}
export function getIconStateName(data, stateId) {
    return sl.getFsrIconStateName(data, stateId).substring(5);
}
